import { createConfirmation } from 'react-confirm'
import { SuccessConfirmationModal } from './success-confirmation-modal'

// create confirm function
const successConfirm = createConfirmation(SuccessConfirmationModal)

export {
  SuccessConfirmationModal,
  successConfirm
}
